import { RouteComponentProps } from "@reach/router";

function Contact(props: RouteComponentProps) {
  return <div>contact</div>;
}

export default Contact;
